import { render, staticRenderFns } from "./Draw.vue?vue&type=template&id=72410412&scoped=true&"
import script from "./Draw.vue?vue&type=script&lang=js&"
export * from "./Draw.vue?vue&type=script&lang=js&"
import style0 from "./Draw.vue?vue&type=style&index=0&id=72410412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72410412",
  null
  
)

export default component.exports